export default {"src":"/_next/static/media/icon-marketplace-star.9e1fc531.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};